import { render, staticRenderFns } from "./ExternalMallManagement.vue?vue&type=template&id=2943af82&scoped=true"
import script from "./ExternalMallManagement.vue?vue&type=script&lang=js"
export * from "./ExternalMallManagement.vue?vue&type=script&lang=js"
import style0 from "./ExternalMallManagement.vue?vue&type=style&index=0&id=2943af82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943af82",
  null
  
)

export default component.exports